import { useEffect } from 'react';
import { useEditor, EditorContent } from '@tiptap/react'
import { common, createLowlight } from 'lowlight'
import html from 'highlight.js/lib/languages/xml'
import StarterKit from '@tiptap/starter-kit'
import Highlight from '@tiptap/extension-highlight';
import TextAlign from '@tiptap/extension-text-align';
import Youtube from '@tiptap/extension-youtube';
import CodeBlockLowlight from '@tiptap/extension-code-block-lowlight'
import MenuBar from './MenuBar';
import { Image } from './extensions/Image/Image';
import FactBox from './extensions/FactBox/FactBox';
import Link from './extensions/Link/Link'
import LeadForm from './extensions/LeadForm/LeadForm';
import { handleFileUpload } from '../../../utils/cloudinary';
import SponsoredLinks from './extensions/SponsoredLinks/SponsoredLinks';
import Video from './extensions/Video/Video';

import './Tiptap.scss';
import './extensions/CodeBlock/CodeBlock.scss';

const lowlight = createLowlight(common)
lowlight.register('html', html)

const Tiptap = ({ value, readOnly, onChange, allowSponsoredLinks }) => {
    const editor = useEditor({
        extensions: [
            StarterKit,
            Highlight,
            TextAlign.configure({
              types: ['heading', 'paragraph'],
            }),
            Link.configure({
                openOnClick: false,
                autolink: false,
            }),
            FactBox,
            Image(handleFileUpload),
            Youtube.configure({
                controls: false
            }),
            Video,
            LeadForm,
            SponsoredLinks,
            CodeBlockLowlight.configure({
              lowlight,
              defaultLanguage: 'html'
            })
        ], 
        content: value,
        editable: !readOnly,
        editorProps: {
            attributes: {
                class: 'prose m-3 min-h-[376px] focus:outline-none max-w-none',
            },
        },
        onUpdate: (e) => {
            onChange && onChange(e.editor.getJSON());
        }
    });

    useEffect(() => {
      editor?.setEditable(!readOnly)
    }, [editor, readOnly])

    // This is the only identified method to update content if it is changed in form
    useEffect(() => {
        if (editor) {
            const isSame = JSON.stringify(editor.getJSON()) === JSON.stringify(value)

            if (isSame) return

            editor.commands.setContent(value);
        }
    }, [editor, value]);

    return (
        <div className='editor'>
            {editor && <MenuBar editor={editor} allowSponsoredLinks={allowSponsoredLinks} />}
            <EditorContent editor={editor} style={{minHeight: "400px"}} />
        </div>
    )
}

export default Tiptap
